export default __webpack_public_path__ + "static/media/SZ01.d8e87708.mp3";